import React, { useState, useEffect } from "react";
import "../../Styles/HomeComponentsStyles/AnalyticsPortion.css";
import DoneIcon from "@mui/icons-material/Done";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CChartImage from "../../images/CChartImage.PNG";
import CFChartImage from "../../images/CFChartImage.PNG";
import EPSChartImage from "../../images/EPSChartImage.PNG";
import GChartImage from "../../images/GChartImage.PNG";
import MCChartImage from "../../images/MCChartImage.PNG";
import MChartImage from "../../images/MChartImage.PNG";
import NIChartImage from "../../images/NIChartImage.PNG";
import OEChartImage from "../../images/OEChartImage.PNG";
import OSChartImage from "../../images/OSChartImage.PNG";
import PEChartImage from "../../images/PEChartImage.PNG";
import priceChartImage from "../../images/priceChartImage.PNG";
import RPChartImage from "../../images/RPChartImage.PNG";
import RMChartImage from "../../images/RMChartImage.PNG";

const AnalyticsPortion = ({ theme }) => {
  const [amount, setAmount] = useState(18);
  const [stocks, setStocks] = useState([]);
  const [chartImagesLinks, setChartImagesLinks] = useState([
    CChartImage,
    EPSChartImage,
    GChartImage,
    RPChartImage,
    MCChartImage,
    CFChartImage,
    NIChartImage,
    OEChartImage,
    OSChartImage,
    PEChartImage,
    MChartImage,
    priceChartImage,
    RMChartImage,
    CChartImage,
    CFChartImage,
    EPSChartImage,
    GChartImage,
    MCChartImage,
    MChartImage,
  ]);
  useEffect(() => {
    let x = [];
    for (let i = 0; i < amount; i++) {
      x.push("1");
    }
    setStocks(x);
  }, []);
  return (
    <div className="analytics__portion">
      <h1 className="sidebar__main__heading__text"> Analytics</h1>
      <h1 className="sidebar__second__main__heading__text">
        Analytics to make sense of its all
      </h1>
      <p className="sidebar__paragraph">
        We are representing our data by using different types of charts like
        line graph, bar chart etc.
      </p>
      <span className="tickpoint one">
        <DoneIcon />
      </span>
      <span className="tickpoint two">
        <DoneIcon />
      </span>
      <span className="tickpoint three">
        <DoneIcon />
      </span>
      <span className="tickpoint four">
        <DoneIcon />
      </span>
      <span className="tickpoint five">
        <DoneIcon />
      </span>
      <span className="tickpoint six">
        <DoneIcon />
      </span>
      <p className="textpoint one">Real time data</p>
      <p className="textpoint two">Revenue and operating income</p>
      <p className="textpoint three">Net income</p>
      <p className="textpoint four">Operating expenses</p>
      <p className="textpoint five">Margins</p>
      <p className="textpoint six">Revenue segments</p>
      <div className="sidebar__btn">
        <span className="text">
          See All Stocks <ArrowForwardIcon />
        </span>
      </div>
      <div className="analytics__slider__container">
        <div className="shade "></div>
        <div className={`wrapper ${theme}`}>
          {/* <div className="rail__one"> */}

          {stocks?.map((s, i) => (
            <div className="box analytics__vectors">
              <img src={chartImagesLinks[i]} />
            </div>
          ))}

          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPortion;

// "https://www.transparentpng.com/thumb/business-growth-chart/business-growth-graph-bar-chart-business-graph-icon-png-4.png",
// "https://www.stash.com/learn/wp-content/uploads/2018/11/CandestickChart_graph.png",
// "https://cdn-icons-png.flaticon.com/512/190/190758.png",
// " https://www.iconpacks.net/icons/1/free-pie-chart-icon-683-thumb.png",
// "https://i.pinimg.com/originals/31/90/3c/31903ce33af0dee5ee82a91e6694badb.png",
// "https://preview.pixlr.com/images/800wm/100/1/1001476022.jpg",
// "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQirtkGTZcRV-ry7_B4TLlninuGk-aMNDWew&usqp=CAU",
// "https://cdn-icons-png.flaticon.com/512/2257/2257295.png",
// "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWzrsw7X-PPNuNql30_nna8F549Sucsro_tiQjQAU27Cc4NepL3SLD1-4IosyLxBOm8nI&usqp=CAU",
// "https://png.pngtree.com/element_our/sm/20180515/sm_5afb10381ebfd.png",
// "https://static.vecteezy.com/system/resources/previews/006/207/959/original/bar-chart-flat-icon-design-vector.jpg",
// "https://cdn-icons-png.flaticon.com/512/2257/2257295.png",
// "https://www.stash.com/learn/wp-content/uploads/2018/11/CandestickChart_graph.png",
// "https://cdn-icons-png.flaticon.com/512/190/190758.png",
// " https://www.iconpacks.net/icons/1/free-pie-chart-icon-683-thumb.png",
// "https://i.pinimg.com/originals/31/90/3c/31903ce33af0dee5ee82a91e6694badb.png",
// "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWzrsw7X-PPNuNql30_nna8F549Sucsro_tiQjQAU27Cc4NepL3SLD1-4IosyLxBOm8nI&usqp=CAU",
// "https://png.pngtree.com/element_our/sm/20180515/sm_5afb10381ebfd.png",
